import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=91fbda92&scoped=true"
import script from "./CreateFolder.vue?vue&type=script&lang=js"
export * from "./CreateFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=91fbda92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fbda92",
  null
  
)

export default component.exports